"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _capturePage = require("./capture-page");
Object.keys(_capturePage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _capturePage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _capturePage[key];
    }
  });
});
var _clientInfo = require("./client-info");
Object.keys(_clientInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _clientInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _clientInfo[key];
    }
  });
});
var _openUrlExternallyOptions = require("./open-url-externally-options");
Object.keys(_openUrlExternallyOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _openUrlExternallyOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _openUrlExternallyOptions[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3BheWxvYWRzL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vY2FwdHVyZS1wYWdlJztcbmV4cG9ydCAqIGZyb20gJy4vY2xpZW50LWluZm8nO1xuZXhwb3J0ICogZnJvbSAnLi9vcGVuLXVybC1leHRlcm5hbGx5LW9wdGlvbnMnO1xuIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBO0FBQUE7RUFBQTtFQUFBO0VBQUE7SUFBQTtJQUFBO01BQUE7SUFBQTtFQUFBO0FBQUE7QUFDQTtBQUFBO0VBQUE7RUFBQTtFQUFBO0lBQUE7SUFBQTtNQUFBO0lBQUE7RUFBQTtBQUFBO0FBQ0E7QUFBQTtFQUFBO0VBQUE7RUFBQTtJQUFBO0lBQUE7TUFBQTtJQUFBO0VBQUE7QUFBQSJ9